import React from 'react';
import { Typography, Tooltip } from 'antd';
import { useAuth } from '../hooks/useAuth';
import { Utils } from '../utils/utils';
import { useGetAdminVersionQuery } from '../services/nestjs-base-api';
import { getAppVersion } from '../utils/version';

const { Text } = Typography;

interface VersionPillProps {
    label: string;
    version: string | undefined;
}

const VersionPill: React.FC<VersionPillProps> = ({ label, version }) => (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', lineHeight: 1.1 }}>
        <Text type="secondary" style={{ fontSize: 10, lineHeight: 1.1 }}>
            {label}
        </Text>
        <Text strong style={{ fontSize: 12, lineHeight: 1.1 }}>
            v{version ?? '—'}
        </Text>
    </div>
);

export const HeaderVersionInfo: React.FC = () => {
    const { user } = useAuth();
    const isPlatformAdmin = user ? Utils.userIsPlatformAdmin(user) : false;

    const { data: version } = useGetAdminVersionQuery(
        { jwtToken: user?.jwtToken || '' },
        { skip: !isPlatformAdmin || !user?.jwtToken },
    );

    if (!isPlatformAdmin) return null;

    const appVersion = getAppVersion();
    const apiVersion = version?.version;
    const surveyVersion = version?.surveyVersion?.version;
    const websiteVersion = version?.websiteVersion?.version;

    return (
        <Tooltip title="App / API / Survey / Website versions" placement="bottom">
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                <VersionPill label="App" version={appVersion} />
                <VersionPill label="API" version={apiVersion} />
                <VersionPill label="Survey" version={surveyVersion} />
                <VersionPill label="Website" version={websiteVersion} />
            </div>
        </Tooltip>
    );
};
